<template>
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="190.712px" height="190.712px" viewBox="0 0 190.712 190.712" style="enable-background:new 0 0 190.712 190.712;"
	 xml:space="preserve">
<g>
	<path d="M188.976,125.657c-2.051-7.098-11.162-8.747-17.617-6.611c-12.936-18.814-32.144-29.435-55.065-26.681
		c-17.817,2.141-39.328,6.837-43.877,26.364c-5.205-3.202-11.924-0.594-14.211,5c-2.437,5.961,2.26,11.216,7.874,11.619
		c-4.373,5.353-5.146,14.076-5.931,20.5c-1.042,8.539-0.444,16.651,4.811,23.635c6.9,9.173,18.805,9.213,20.406-2.34
		c11.133,2.867,22.498,3.064,33.988,4.031c10.654,0.896,21.446,2.137,31.874-0.57c-0.488,10.666,12.69,9.912,20.115,5.074
		c14.322-9.332,10.99-32.972,6.524-47.394C184.697,138.667,191.027,132.754,188.976,125.657z M113.125,97.748
		c23.627-3.912,37.217,7.238,52.688,22.206c-30.492,8.498-59.157,7.383-88.845-3.677C85.389,103.967,98.074,100.24,113.125,97.748z
		 M183.41,132.483c-2.286,1.33-5.044,1.232-7.559,1.638c-0.541,0.087-0.912,0.384-1.148,0.769c-1.088,0.223-2.001,1.158-1.574,2.541
		c3.823,12.393,4.551,25.526,0.849,38.031c-1.227,4.143-5.936,7.209-9.654,8.768c-5.598,2.349-8.592-0.266-10.063-5.166
		c0.612-1.375-0.511-3.327-2.479-2.989c-20.875,3.579-45.158,0.812-66.316-2.032c-0.39-1.357-2.348-1.596-3.07-0.373
		c-1.373-0.017-1.975,1.715-0.789,2.37c-1.541,4.771-3.803,8.429-9.499,4.878c-3.913-2.439-6.455-7.162-7.623-11.461
		c-1.746-6.428,0.064-14.509,1.445-20.79c1.015-4.62,3.272-9.175,3.286-13.922c0.284-0.468,0.166-1.112-0.243-1.517
		c-0.042-0.039-0.082-0.069-0.13-0.096c-0.103-0.074-0.173-0.185-0.303-0.222c-4.021-1.144-8.171-2.888-6.916-7.844
		c0.474-1.868,1.821-3.286,3.517-4.117c2.435-1.192,4.812,0.112,7.128,0.802c0.119,0.035,0.234,0.034,0.351,0.034
		c0.455,0.257,1.033,0.218,1.341-0.399c0.501-1.002,1.024-1.955,1.567-2.871c28.566,14.828,62.441,15.936,92.602,5.138
		c0.604-0.216,0.995-0.611,1.219-1.069c0.224,0.01,0.447,0.041,0.667-0.01c4.734,0.303,10.872-0.762,14.562,2.794
		c1.014,0.976,1.563,2.608,1.665,3.968C186.366,131.024,184.594,131.793,183.41,132.483z"/>
	<path d="M92.833,145.11c-0.545-3.445-4.354-7.422-8.025-6.463c-4.656-1.502-8.688,2.273-9.091,7.08
		c-0.461,5.5,4.091,10.066,9.631,9.397C90.243,154.533,93.6,149.955,92.833,145.11z M85.193,150.496
		c-2.879,0.746-4.626-1.821-4.656-4.343c-0.027-2.278,1.562-3.643,3.46-4.383c2.34,0.5,4.413,0.379,4.583,3.527
		C88.706,147.647,87.532,149.889,85.193,150.496z"/>
	<path d="M158.874,141.821c-0.032-0.027-0.039-0.074-0.077-0.098c-4.456-2.58-9.229,0.131-11.021,4.584
		c-2.111,5.246,1.109,9.969,6.384,11.14c5.132,1.14,10.185-1.929,11.09-7.207C165.917,146.344,162.868,141.803,158.874,141.821z
		 M160.879,149.25c-0.288,2.812-2.887,4.375-5.532,3.888c-6.178-1.141-3.651-8.004,0.745-9.519c0.059,0.251,0.188,0.483,0.498,0.625
		C159.169,145.436,161.215,145.959,160.879,149.25z"/>
	<path d="M127.216,68.8c-2.957-1.774-6.76-1.876-10.219-1.321c-3.864-49.641-83.401-42.894-99.246-4.022
		c-2.797-2.121-7.146-2.963-10.223-1.669c-3.343,1.407-5.198,4.678-5.702,8.164C1.303,73.578,1.952,77.16,4.266,80.05
		c1.369,1.71,3.319,2.468,5.302,2.431c-6.282,13.821-14.425,31.212-5.877,45.25c3.799,6.24,12.847,9.4,19.792,7.597
		c11.266-2.925,13.831-15.04,26.31-14.546c1.876,0.074,1.922-2.43,0.411-3.036c-4.025-1.619-12.035-3.901-15.622,0.201
		c-2.279,2.604-2.824,5.745-4.981,8.536c-5.092,6.588-15.468,4.63-20.85-0.047c-11.509-10,1.374-34.53,5.569-45.567
		c0.713-1.876-2.252-3.19-3.245-1.609c-3.716-0.543-5.015-4.392-4.669-8.313c0.16-1.817,1.038-3.764,2.624-4.735
		c2.745-1.681,5.638,1.047,8.217,1.549c0.811,0.158,1.716-0.293,2.161-0.972c0.179-0.112,0.344-0.256,0.472-0.456
		c0.425-0.661,0.888-1.295,1.339-1.937c28.557,8.969,61.823,10.181,91.136,5.031c0.393,1.349,1.717,1.848,2.876,1.63
		c4.77-0.632,13.442-0.323,12.139,6.655c-0.45,2.41-2.738,3.126-4.893,3.103c-2.743-0.029-4.445-1.994-6.911-2.557
		c-1.285-0.293-2.589,0.837-2.189,2.189c1.068,3.615,6.369,4.891,9.663,4.798c3.795-0.108,6.914-2.299,8.191-5.852
		C132.669,75.389,130.726,70.905,127.216,68.8z M22.309,62.874c22.635-29.992,74.332-36.875,88.744,2.534
		C80.755,69.424,52.396,65.027,22.309,62.874z"/>
	<path d="M35.346,85.364c-1.555-1.972-4.139-3.148-6.626-3.134c-2.222,0.013-4.987,1.341-6.05,3.408
		c-3.061,2.25-4.413,6.413-3.353,10.439c1.787,6.789,10.043,7.398,14.995,3.697C39.083,96.209,38.778,89.715,35.346,85.364z
		 M31.588,96.194c-2.762,1.927-6.808,1.742-7.801-1.825c-0.556-1.996,0.002-4.133,1.078-5.955c1.384-0.573,2.391-1.856,3.946-2.223
		c1.379-0.325,2.566,0.749,3.386,1.688C34.279,90.258,34.263,94.329,31.588,96.194z"/>
	<path d="M187.18,35.873c-3.7-2.667-8.422-1.955-12.503-0.563C168.41-5.358,93.032-10.149,77.7,26.216
		c-0.802,1.903,2.341,3.157,3.295,1.389c17.719-32.79,76.265-25.078,89.756,7.67c-19.938,6.814-38.964,6.741-59.465,3.116
		c-0.587-0.104-1.027,0.333-0.922,0.922c1.273,7.051,18.041,6.014,22.949,6.09c13.261,0.206,27.625,0.41,38.999-7.281
		c0.251,0.828,1.02,1.469,2.163,1.173c4.349-1.125,12.918-1.709,11.562,5.259c-0.427,2.197-1.768,4.203-3.61,5.463
		c-1.048,0.716-2.275,1.136-3.53,1.296c-1.601,0.204-3.205-0.313-4.646,0.625c-0.228,0.148-0.413,0.349-0.564,0.571
		c-0.354,0.315-0.539,0.802-0.347,1.424c3.15,10.177,5.493,19.758,5.115,30.534c-0.094,2.673-2.468,21.692-9.633,15.363
		c-3.338-2.948-4.45-7.814-5.563-11.909c-0.143-0.523-0.486-0.858-0.896-1.05c-1.346-6.146-14.443-8.643-19.46-8.282
		c-2.611,0.188-3.025,3.567-0.604,4.462c5.097,1.883,13.222,0.607,17.768,4.412c-0.162,0.255-0.277,0.55-0.259,0.925
		c0.425,8.677,9.599,25.007,18.577,13.853c8.741-10.861,6.625-33.062-0.09-45.794c2.409-0.105,5.023-1.127,6.609-2.192
		c3.176-2.133,5.28-5.707,5.725-9.488C191.025,41.393,190.022,37.922,187.18,35.873z"/>
	<path d="M168.323,62.33c-0.739-2.153-2.294-4.051-4.437-4.9c-1.67-0.661-4.602-0.802-5.893,0.703
		c-0.787,0.047-1.548,0.299-2.363,0.912c-1.711,1.286-2.308,3.479-2.571,5.502c-0.62,4.75,3.338,8.773,8.012,8.514
		C166.484,72.761,170.082,67.453,168.323,62.33z M160.649,68.008c-3.642,0.366-4.014-5.737-1.816-7.61
		c1.122,0.175,2.188-0.375,3.318,0.248c1.048,0.578,1.455,1.83,1.667,2.925C164.277,65.95,163.043,67.768,160.649,68.008z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
